module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_desktop_02@2x-5308203c5e8ecfdbaa0547b139cd7d48.jpg";